import { render } from "./MypageHeader.vue?vue&type=template&id=7531919d"
import script from "./MypageHeader.vue?vue&type=script&lang=js"
export * from "./MypageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__